import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './__root';

// Code splitting: Lazy load SharedPhotoPage
const SharedPhotoPage = lazy(() =>
  import('@/pages/SharedPhotoPage').then((m) => ({ default: m.SharedPhotoPage }))
);

export const sharedPhotoRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/share/photo/$token',
  component: SharedPhotoPage,
});

// Backward compatibility
export const Route = sharedPhotoRoute;
